import { render, staticRenderFns } from "./UploadResources.vue?vue&type=template&id=8c6ab64e&scoped=true"
import script from "./UploadResources.vue?vue&type=script&lang=ts"
export * from "./UploadResources.vue?vue&type=script&lang=ts"
import style0 from "./UploadResources.vue?vue&type=style&index=0&id=8c6ab64e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6ab64e",
  null
  
)

export default component.exports